import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { parseHtmlToReact, prepareForParse } from '../../utils'

function CustomStaffList({ data: { pageContext, ...pageData } }) {
  // Template 取得
  const { locale } = pageContext
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    query {
      allContentfulTemplate(filter: { name: { eq: "customStaffList" } }) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
        }
      }
    }
  `)
  const template = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale
  )
  if (template === undefined) {
    throw new Error(`Template not found: ${locale}`)
  }

  return pageData.pageAllContentfulDoctor.nodes.map((node, index) => {
    const { htmlBody, componentData } = prepareForParse({
      template,
      data: {
        ...pageData,
        contentfulDoctor: node,
      },
      pageContext,
    })

    return (
      <React.Fragment key={index}>
        {parseHtmlToReact(htmlBody, componentData)}
      </React.Fragment>
    )
  })
}

export { CustomStaffList }
